// extracted by mini-css-extract-plugin
export default {"wrapper":"timer_wrapper__Hqhkx","disable":"timer_disable__HgYEo"};